// Auto-generated by @decocms/blocks-cli/scripts/generate-sections.ts
// Do not edit manually. Add convention exports to your section files instead.
//
// Supported conventions:
//   export const eager = true       → prefer eager (defers past fold threshold)
//   export const neverDefer = true  → ALWAYS eager, ignores fold threshold
//   export const cache = "listing"  → SWR-cached section loader results
//   export const layout = true      → cached as layout (Header, Footer, Theme)
//   export const sync = true        → bundled synchronously (not lazy-loaded)
//   export const clientOnly = true  → skip SSR (client-only rendering)
//   export const seo = true         → SEO section (provides page head data)
//   export function LoadingFallback → skeleton shown while section loads
//   export const renderJson = false → drop section from ?renderJson (mobile)
//   export const renderJson = (p)=> → project props for ?renderJson (mobile)

import * as _sync0 from "../src/sections/Content/BenefitsSection";
import * as _sync1 from "../src/sections/Footer/Footer";
import * as _sync2 from "../src/sections/Header/Header";
import * as _sync3 from "../src/sections/Images/Carousel";
import * as _sync4 from "../src/sections/Images/Image";
import * as _sync5 from "../src/sections/Layout/Space";
import * as _sync6 from "../src/sections/Miscellaneous/FloatingButtons";
import * as _sync7 from "../src/sections/Modals/Minicart";
import * as _sync8 from "../src/sections/Product/ProductDetails";
import * as _sync9 from "../src/sections/Product/SearchResult";
import * as _sync10 from "../src/sections/Store/ProductGallery";
import * as _sync11 from "../src/sections/Store/Space";
import * as _sync12 from "../src/sections/Theme/Theme";
import { LoadingFallback as _fb0 } from "../src/sections/BannerLinks/BannerLinks";
import { LoadingFallback as _fb1 } from "../src/sections/BlackFriday/FAQ";
import { LoadingFallback as _fb2 } from "../src/sections/BlackFriday/GoToSubscribe";
import { LoadingFallback as _fb3 } from "../src/sections/BlackFriday/Highlights";
import { LoadingFallback as _fb4 } from "../src/sections/BlackFriday/Subscribe";
import { LoadingFallback as _fb5 } from "../src/sections/BlackFriday/Text";
import { LoadingFallback as _fb6 } from "../src/sections/BlogText/BlogText";
import { LoadingFallback as _fb7 } from "../src/sections/BrandCustomPage/BrandBanner";
import { LoadingFallback as _fb8 } from "../src/sections/BrandCustomPage/BrandBannerMosaic";
import { LoadingFallback as _fb9 } from "../src/sections/BrandCustomPage/BrandContact";
import { LoadingFallback as _fb10 } from "../src/sections/BrandCustomPage/BrandFilters";
import { LoadingFallback as _fb11 } from "../src/sections/BrandCustomPage/BrandProducts";
import { LoadingFallback as _fb12 } from "../src/sections/BrandCustomPage/BrandSeoBottom";
import { LoadingFallback as _fb13 } from "../src/sections/BrandCustomPage/BrandSeoTop";
import { LoadingFallback as _fb14 } from "../src/sections/BrandCustomPage/BrandTabbedProductShelf";
import { LoadingFallback as _fb15 } from "../src/sections/Breadcrumb/Breadcrumb";
import { LoadingFallback as _fb16 } from "../src/sections/Category/CategoryBanner";
import { LoadingFallback as _fb17 } from "../src/sections/Category/CategoryList";
import { LoadingFallback as _fb18 } from "../src/sections/CategorySwiper/CategorySwiper";
import { LoadingFallback as _fb19 } from "../src/sections/Content/Benefits";
import { LoadingFallback as _fb20 } from "../src/sections/Content/Blog";
import { LoadingFallback as _fb21 } from "../src/sections/Content/Diferenciais";
import { LoadingFallback as _fb22 } from "../src/sections/Content/Faq";
import { LoadingFallback as _fb23 } from "../src/sections/Content/FreeShipping";
import { LoadingFallback as _fb24 } from "../src/sections/Content/FreightBar";
import { LoadingFallback as _fb25 } from "../src/sections/Content/Logos";
import { LoadingFallback as _fb26 } from "../src/sections/Content/Testimonials";
import { LoadingFallback as _fb27 } from "../src/sections/Content/TopSales";
import { LoadingFallback as _fb28 } from "../src/sections/Glossary/Glossary";
import { LoadingFallback as _fb29 } from "../src/sections/Glossary/GlossaryBanner";
import { LoadingFallback as _fb30 } from "../src/sections/Glossary/GlossaryBrands";
import { LoadingFallback as _fb31 } from "../src/sections/Glossary/GlossaryContact";
import { LoadingFallback as _fb32 } from "../src/sections/Images/BannerGrid";
import { LoadingFallback as _fb33 } from "../src/sections/Images/ImageGallery";
import { LoadingFallback as _fb34 } from "../src/sections/Images/ImageGalleryCenter";
import { LoadingFallback as _fb35 } from "../src/sections/Images/ShoppableBanner";
import { LoadingFallback as _fb36 } from "../src/sections/Institutional/Banner";
import { LoadingFallback as _fb37 } from "../src/sections/Institutional/ContactForm";
import { LoadingFallback as _fb38 } from "../src/sections/Institutional/FAQ-new";
import { LoadingFallback as _fb39 } from "../src/sections/Institutional/FAQ";
import { LoadingFallback as _fb40 } from "../src/sections/Institutional/Institutional";
import { LoadingFallback as _fb41 } from "../src/sections/Institutional/OctaDeskForm";
import { LoadingFallback as _fb42 } from "../src/sections/Institutional/Text";
import { LoadingFallback as _fb43 } from "../src/sections/Konfidency/StoreReviewCarousel";
import { LoadingFallback as _fb44 } from "../src/sections/Links/LinkTree";
import { LoadingFallback as _fb45 } from "../src/sections/Links/Shortcuts";
import { LoadingFallback as _fb46 } from "../src/sections/Lives/Live";
import { LoadingFallback as _fb47 } from "../src/sections/Lives/NizzaPlayer";
import { LoadingFallback as _fb48 } from "../src/sections/Miscellaneous/CampaignTimer";
import { LoadingFallback as _fb49 } from "../src/sections/Miscellaneous/CookieConsent";
import { LoadingFallback as _fb50 } from "../src/sections/Newsletter/Newsletter";
import { LoadingFallback as _fb51 } from "../src/sections/Newsletter/NewsletterPopup";
import { LoadingFallback as _fb52 } from "../src/sections/Product/BuyTogether";
import { LoadingFallback as _fb53 } from "../src/sections/Product/CountdownProductShelf";
import { LoadingFallback as _fb54 } from "../src/sections/Product/ImageGalleryFrontBack";
import { LoadingFallback as _fb55 } from "../src/sections/Product/NotFound";
import { LoadingFallback as _fb56 } from "../src/sections/Product/ProductBlogPosts";
import { LoadingFallback as _fb57 } from "../src/sections/Product/ProductDescription";
import { LoadingFallback as _fb58 } from "../src/sections/Product/ProductShelf";
import { LoadingFallback as _fb59 } from "../src/sections/Product/TESTSearchResultWithoutFilters";
import { LoadingFallback as _fb60 } from "../src/sections/Product/Wishlist";
import { LoadingFallback as _fb61 } from "../src/sections/PromotionLinks/PromotionLinks";
import { LoadingFallback as _fb62 } from "../src/sections/ResaleCatalog/Resale";
import { LoadingFallback as _fb63 } from "../src/sections/ResaleLingerie/Benefits";
import { LoadingFallback as _fb64 } from "../src/sections/ResaleLingerie/Content";
import { LoadingFallback as _fb65 } from "../src/sections/ResaleLingerie/Differentials";
import { LoadingFallback as _fb66 } from "../src/sections/ResaleLingerie/Hero";
import { LoadingFallback as _fb67 } from "../src/sections/ResaleLingerie/Products";
import { LoadingFallback as _fb68 } from "../src/sections/ResaleLingerie/Sets";
import { LoadingFallback as _fb69 } from "../src/sections/SEO/CustomSEOPLP";
import { LoadingFallback as _fb70 } from "../src/sections/SEO/PageSEO";
import { LoadingFallback as _fb71 } from "../src/sections/Scripts/RedirectDepartments";
import { LoadingFallback as _fb72 } from "../src/sections/Social/InstagramPosts";
import { LoadingFallback as _fb73 } from "../src/sections/Store/RichText";
import { LoadingFallback as _fb74 } from "../src/sections/v2/search/SearchBanner";

export interface SectionMetaEntry {
  eager?: boolean;
  neverDefer?: boolean;
  deferred?: boolean;
  cache?: string;
  layout?: boolean;
  sync?: boolean;
  clientOnly?: boolean;
  seo?: boolean;
  hasLoadingFallback?: boolean;
  renderJson?: false;
  hasRenderJson?: boolean;
}

export const sectionMeta: Record<string, SectionMetaEntry> = {
  "site/sections/BannerLinks/BannerLinks.tsx": { hasLoadingFallback: true },
  "site/sections/BlackFriday/FAQ.tsx": { hasLoadingFallback: true },
  "site/sections/BlackFriday/GoToSubscribe.tsx": { hasLoadingFallback: true },
  "site/sections/BlackFriday/Highlights.tsx": { hasLoadingFallback: true },
  "site/sections/BlackFriday/Subscribe.tsx": { hasLoadingFallback: true },
  "site/sections/BlackFriday/Text.tsx": { hasLoadingFallback: true },
  "site/sections/BlogText/BlogText.tsx": { hasLoadingFallback: true },
  "site/sections/BrandCustomPage/BrandBanner.tsx": { hasLoadingFallback: true },
  "site/sections/BrandCustomPage/BrandBannerMosaic.tsx": { hasLoadingFallback: true },
  "site/sections/BrandCustomPage/BrandContact.tsx": { hasLoadingFallback: true },
  "site/sections/BrandCustomPage/BrandFilters.tsx": { hasLoadingFallback: true },
  "site/sections/BrandCustomPage/BrandProducts.tsx": { hasLoadingFallback: true },
  "site/sections/BrandCustomPage/BrandSeoBottom.tsx": { hasLoadingFallback: true },
  "site/sections/BrandCustomPage/BrandSeoTop.tsx": { hasLoadingFallback: true },
  "site/sections/BrandCustomPage/BrandTabbedProductShelf.tsx": { hasLoadingFallback: true },
  "site/sections/Breadcrumb/Breadcrumb.tsx": { hasLoadingFallback: true },
  "site/sections/Category/CategoryBanner.tsx": { hasLoadingFallback: true },
  "site/sections/Category/CategoryList.tsx": { hasLoadingFallback: true },
  "site/sections/CategorySwiper/CategorySwiper.tsx": { hasLoadingFallback: true },
  "site/sections/Content/Benefits.tsx": { hasLoadingFallback: true },
  "site/sections/Content/BenefitsSection.tsx": { sync: true, hasLoadingFallback: true },
  "site/sections/Content/Blog.tsx": { hasLoadingFallback: true },
  "site/sections/Content/Diferenciais.tsx": { hasLoadingFallback: true },
  "site/sections/Content/Faq.tsx": { hasLoadingFallback: true },
  "site/sections/Content/FreeShipping.tsx": { hasLoadingFallback: true },
  "site/sections/Content/FreightBar.tsx": { hasLoadingFallback: true },
  "site/sections/Content/Logos.tsx": { hasLoadingFallback: true },
  "site/sections/Content/Testimonials.tsx": { hasLoadingFallback: true },
  "site/sections/Content/TopSales.tsx": { hasLoadingFallback: true },
  "site/sections/Footer/Footer.tsx": { eager: true, sync: true, hasLoadingFallback: true },
  "site/sections/Glossary/Glossary.tsx": { hasLoadingFallback: true },
  "site/sections/Glossary/GlossaryBanner.tsx": { hasLoadingFallback: true },
  "site/sections/Glossary/GlossaryBrands.tsx": { hasLoadingFallback: true },
  "site/sections/Glossary/GlossaryContact.tsx": { hasLoadingFallback: true },
  "site/sections/Header/Header.tsx": { eager: true, sync: true, hasLoadingFallback: true },
  "site/sections/Images/BannerGrid.tsx": { hasLoadingFallback: true },
  "site/sections/Images/Carousel.tsx": { sync: true, hasLoadingFallback: true },
  "site/sections/Images/Image.tsx": { sync: true, hasLoadingFallback: true },
  "site/sections/Images/ImageGallery.tsx": { hasLoadingFallback: true },
  "site/sections/Images/ImageGalleryCenter.tsx": { hasLoadingFallback: true },
  "site/sections/Images/ShoppableBanner.tsx": { hasLoadingFallback: true },
  "site/sections/Institutional/Banner.tsx": { hasLoadingFallback: true },
  "site/sections/Institutional/ContactForm.tsx": { hasLoadingFallback: true },
  "site/sections/Institutional/FAQ-new.tsx": { hasLoadingFallback: true },
  "site/sections/Institutional/FAQ.tsx": { hasLoadingFallback: true },
  "site/sections/Institutional/Institutional.tsx": { hasLoadingFallback: true },
  "site/sections/Institutional/OctaDeskForm.tsx": { hasLoadingFallback: true },
  "site/sections/Institutional/Text.tsx": { hasLoadingFallback: true },
  "site/sections/Konfidency/StoreReviewCarousel.tsx": { hasLoadingFallback: true },
  "site/sections/Layout/Space.tsx": { sync: true },
  "site/sections/Links/LinkTree.tsx": { hasLoadingFallback: true },
  "site/sections/Links/Shortcuts.tsx": { hasLoadingFallback: true },
  "site/sections/Lives/Live.tsx": { hasLoadingFallback: true },
  "site/sections/Lives/NizzaPlayer.tsx": { hasLoadingFallback: true },
  "site/sections/Miscellaneous/CampaignTimer.tsx": { hasLoadingFallback: true },
  "site/sections/Miscellaneous/CookieConsent.tsx": { hasLoadingFallback: true },
  "site/sections/Miscellaneous/FloatingButtons.tsx": { sync: true, hasLoadingFallback: true },
  "site/sections/Modals/Minicart.tsx": { sync: true },
  "site/sections/Newsletter/Newsletter.tsx": { hasLoadingFallback: true },
  "site/sections/Newsletter/NewsletterPopup.tsx": { hasLoadingFallback: true },
  "site/sections/Product/BuyTogether.tsx": { deferred: true, hasLoadingFallback: true },
  "site/sections/Product/CountdownProductShelf.tsx": { hasLoadingFallback: true },
  "site/sections/Product/ImageGalleryFrontBack.tsx": { hasLoadingFallback: true },
  "site/sections/Product/NotFound.tsx": { hasLoadingFallback: true },
  "site/sections/Product/ProductBlogPosts.tsx": { hasLoadingFallback: true },
  "site/sections/Product/ProductDescription.tsx": { hasLoadingFallback: true },
  "site/sections/Product/ProductDetails.tsx": { sync: true, hasLoadingFallback: true },
  "site/sections/Product/ProductShelf.tsx": { hasLoadingFallback: true },
  "site/sections/Product/SearchResult.tsx": { neverDefer: true, sync: true, hasLoadingFallback: true },
  "site/sections/Product/TESTSearchResultWithoutFilters.tsx": { hasLoadingFallback: true },
  "site/sections/Product/Wishlist.tsx": { hasLoadingFallback: true },
  "site/sections/PromotionLinks/PromotionLinks.tsx": { hasLoadingFallback: true },
  "site/sections/ResaleCatalog/Resale.tsx": { hasLoadingFallback: true },
  "site/sections/ResaleLingerie/Benefits.ts": { hasLoadingFallback: true },
  "site/sections/ResaleLingerie/Content.tsx": { hasLoadingFallback: true },
  "site/sections/ResaleLingerie/Differentials.tsx": { hasLoadingFallback: true },
  "site/sections/ResaleLingerie/Hero.tsx": { hasLoadingFallback: true },
  "site/sections/ResaleLingerie/Products.ts": { hasLoadingFallback: true },
  "site/sections/ResaleLingerie/Sets.ts": { hasLoadingFallback: true },
  "site/sections/SEO/CustomSEO.tsx": { seo: true },
  "site/sections/SEO/CustomSEOPDP.tsx": { seo: true },
  "site/sections/SEO/CustomSEOPLP.tsx": { seo: true, hasLoadingFallback: true },
  "site/sections/SEO/PageSEO.tsx": { seo: true, hasLoadingFallback: true },
  "site/sections/Scripts/RedirectDepartments.ts": { hasLoadingFallback: true },
  "site/sections/Social/InstagramPosts.tsx": { cache: "static", hasLoadingFallback: true },
  "site/sections/Store/ProductGallery.tsx": { sync: true, hasLoadingFallback: true },
  "site/sections/Store/RichText.tsx": { hasLoadingFallback: true },
  "site/sections/Store/Space.tsx": { sync: true, hasLoadingFallback: true },
  "site/sections/Theme/Theme.tsx": { eager: true, sync: true, layout: true },
  "site/sections/v2/search/SearchBanner.ts": { hasLoadingFallback: true },
};

export const syncComponents: Record<string, any> = {
  "site/sections/Content/BenefitsSection.tsx": _sync0,
  "site/sections/Footer/Footer.tsx": _sync1,
  "site/sections/Header/Header.tsx": _sync2,
  "site/sections/Images/Carousel.tsx": _sync3,
  "site/sections/Images/Image.tsx": _sync4,
  "site/sections/Layout/Space.tsx": _sync5,
  "site/sections/Miscellaneous/FloatingButtons.tsx": _sync6,
  "site/sections/Modals/Minicart.tsx": _sync7,
  "site/sections/Product/ProductDetails.tsx": _sync8,
  "site/sections/Product/SearchResult.tsx": _sync9,
  "site/sections/Store/ProductGallery.tsx": _sync10,
  "site/sections/Store/Space.tsx": _sync11,
  "site/sections/Theme/Theme.tsx": _sync12,
};

export const loadingFallbacks: Record<string, React.ComponentType<any>> = {
  "site/sections/BannerLinks/BannerLinks.tsx": _fb0,
  "site/sections/BlackFriday/FAQ.tsx": _fb1,
  "site/sections/BlackFriday/GoToSubscribe.tsx": _fb2,
  "site/sections/BlackFriday/Highlights.tsx": _fb3,
  "site/sections/BlackFriday/Subscribe.tsx": _fb4,
  "site/sections/BlackFriday/Text.tsx": _fb5,
  "site/sections/BlogText/BlogText.tsx": _fb6,
  "site/sections/BrandCustomPage/BrandBanner.tsx": _fb7,
  "site/sections/BrandCustomPage/BrandBannerMosaic.tsx": _fb8,
  "site/sections/BrandCustomPage/BrandContact.tsx": _fb9,
  "site/sections/BrandCustomPage/BrandFilters.tsx": _fb10,
  "site/sections/BrandCustomPage/BrandProducts.tsx": _fb11,
  "site/sections/BrandCustomPage/BrandSeoBottom.tsx": _fb12,
  "site/sections/BrandCustomPage/BrandSeoTop.tsx": _fb13,
  "site/sections/BrandCustomPage/BrandTabbedProductShelf.tsx": _fb14,
  "site/sections/Breadcrumb/Breadcrumb.tsx": _fb15,
  "site/sections/Category/CategoryBanner.tsx": _fb16,
  "site/sections/Category/CategoryList.tsx": _fb17,
  "site/sections/CategorySwiper/CategorySwiper.tsx": _fb18,
  "site/sections/Content/Benefits.tsx": _fb19,
  "site/sections/Content/BenefitsSection.tsx": _sync0.LoadingFallback,
  "site/sections/Content/Blog.tsx": _fb20,
  "site/sections/Content/Diferenciais.tsx": _fb21,
  "site/sections/Content/Faq.tsx": _fb22,
  "site/sections/Content/FreeShipping.tsx": _fb23,
  "site/sections/Content/FreightBar.tsx": _fb24,
  "site/sections/Content/Logos.tsx": _fb25,
  "site/sections/Content/Testimonials.tsx": _fb26,
  "site/sections/Content/TopSales.tsx": _fb27,
  "site/sections/Footer/Footer.tsx": _sync1.LoadingFallback,
  "site/sections/Glossary/Glossary.tsx": _fb28,
  "site/sections/Glossary/GlossaryBanner.tsx": _fb29,
  "site/sections/Glossary/GlossaryBrands.tsx": _fb30,
  "site/sections/Glossary/GlossaryContact.tsx": _fb31,
  "site/sections/Header/Header.tsx": _sync2.LoadingFallback,
  "site/sections/Images/BannerGrid.tsx": _fb32,
  "site/sections/Images/Carousel.tsx": _sync3.LoadingFallback,
  "site/sections/Images/Image.tsx": _sync4.LoadingFallback,
  "site/sections/Images/ImageGallery.tsx": _fb33,
  "site/sections/Images/ImageGalleryCenter.tsx": _fb34,
  "site/sections/Images/ShoppableBanner.tsx": _fb35,
  "site/sections/Institutional/Banner.tsx": _fb36,
  "site/sections/Institutional/ContactForm.tsx": _fb37,
  "site/sections/Institutional/FAQ-new.tsx": _fb38,
  "site/sections/Institutional/FAQ.tsx": _fb39,
  "site/sections/Institutional/Institutional.tsx": _fb40,
  "site/sections/Institutional/OctaDeskForm.tsx": _fb41,
  "site/sections/Institutional/Text.tsx": _fb42,
  "site/sections/Konfidency/StoreReviewCarousel.tsx": _fb43,
  "site/sections/Links/LinkTree.tsx": _fb44,
  "site/sections/Links/Shortcuts.tsx": _fb45,
  "site/sections/Lives/Live.tsx": _fb46,
  "site/sections/Lives/NizzaPlayer.tsx": _fb47,
  "site/sections/Miscellaneous/CampaignTimer.tsx": _fb48,
  "site/sections/Miscellaneous/CookieConsent.tsx": _fb49,
  "site/sections/Miscellaneous/FloatingButtons.tsx": _sync6.LoadingFallback,
  "site/sections/Newsletter/Newsletter.tsx": _fb50,
  "site/sections/Newsletter/NewsletterPopup.tsx": _fb51,
  "site/sections/Product/BuyTogether.tsx": _fb52,
  "site/sections/Product/CountdownProductShelf.tsx": _fb53,
  "site/sections/Product/ImageGalleryFrontBack.tsx": _fb54,
  "site/sections/Product/NotFound.tsx": _fb55,
  "site/sections/Product/ProductBlogPosts.tsx": _fb56,
  "site/sections/Product/ProductDescription.tsx": _fb57,
  "site/sections/Product/ProductDetails.tsx": _sync8.LoadingFallback,
  "site/sections/Product/ProductShelf.tsx": _fb58,
  "site/sections/Product/SearchResult.tsx": _sync9.LoadingFallback,
  "site/sections/Product/TESTSearchResultWithoutFilters.tsx": _fb59,
  "site/sections/Product/Wishlist.tsx": _fb60,
  "site/sections/PromotionLinks/PromotionLinks.tsx": _fb61,
  "site/sections/ResaleCatalog/Resale.tsx": _fb62,
  "site/sections/ResaleLingerie/Benefits.ts": _fb63,
  "site/sections/ResaleLingerie/Content.tsx": _fb64,
  "site/sections/ResaleLingerie/Differentials.tsx": _fb65,
  "site/sections/ResaleLingerie/Hero.tsx": _fb66,
  "site/sections/ResaleLingerie/Products.ts": _fb67,
  "site/sections/ResaleLingerie/Sets.ts": _fb68,
  "site/sections/SEO/CustomSEOPLP.tsx": _fb69,
  "site/sections/SEO/PageSEO.tsx": _fb70,
  "site/sections/Scripts/RedirectDepartments.ts": _fb71,
  "site/sections/Social/InstagramPosts.tsx": _fb72,
  "site/sections/Store/ProductGallery.tsx": _sync10.LoadingFallback,
  "site/sections/Store/RichText.tsx": _fb73,
  "site/sections/Store/Space.tsx": _sync11.LoadingFallback,
  "site/sections/v2/search/SearchBanner.ts": _fb74,
};

export const renderJsons: Record<string, any> = {};
